{
  "language": {
    "label": "Language",
    "description": "Interface language. New workspaces inherit this language for their generated reports.",
    "english": "English",
    "french": "Français",
    "chinese": "中文"
  },
  "settings": {
    "title": "Settings",
    "appearance": "Appearance",
    "darkMode": "Dark mode",
    "darkModeOnDescription": "Currently using dark theme",
    "darkModeOffDescription": "Currently using light theme",
    "dangerZone": "Danger zone",
    "clearAll": "Purge everything",
    "clearAllDescription": "Permanently delete all projects, files, reports, logs and models",
    "purge": "Purge"
  },
  "modelSet": {
    "title": "Model set",
    "label": "Model set",
    "choose": "Choose",
    "loading": "Loading model sets…",
    "noneAvailable": "No model sets are available right now.",
    "appliesAll": "This applies to the whole deployment and every workspace. A change takes effect on the next model call; work already running is not changed.",
    "errorTimeout": "The request took too long. Please try again.",
    "errorNetwork": "We couldn't reach the server. Check your connection and try again.",
    "errorGeneric": "Something went wrong. Please try again."
  },
  "workspace": {
    "createTitle": "Create workspace",
    "outputLanguage": "Report language",
    "outputLanguageHint": "Generated reports for this workspace will be written in this language. This cannot be changed after creation.",
    "outputLanguageLockedHint": "Report language is locked after creation.",
    "create": "Create",
    "cancel": "Cancel"
  },
  "actions": {
    "ok": "OK",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "confirm": "Confirm",
    "submit": "Submit",
    "next": "Next",
    "previous": "Previous",
    "back": "Back",
    "continue": "Continue",
    "retry": "Retry",
    "refresh": "Refresh",
    "copy": "Copy",
    "copied": "Copied",
    "download": "Download",
    "upload": "Upload",
    "remove": "Remove",
    "add": "Add",
    "rename": "Rename",
    "search": "Search",
    "filter": "Filter",
    "clear": "Clear",
    "loading": "Loading...",
    "approve": "Approve",
    "reject": "Reject",
    "open": "Open",
    "view": "View",
    "more": "More",
    "less": "Less",
    "yes": "Yes",
    "no": "No"
  },
  "status": {
    "loading": "Loading...",
    "saving": "Saving...",
    "saved": "Saved",
    "ready": "Ready",
    "error": "Error",
    "pending": "Pending",
    "complete": "Complete",
    "failed": "Failed",
    "draft": "Draft",
    "approved": "Approved",
    "rejected": "Rejected"
  },
  "time": {
    "justNow": "just now",
    "minutesAgo_one": "{{count}} minute ago",
    "minutesAgo_other": "{{count}} minutes ago",
    "hoursAgo_one": "{{count}} hour ago",
    "hoursAgo_other": "{{count}} hours ago",
    "daysAgo_one": "{{count}} day ago",
    "daysAgo_other": "{{count}} days ago"
  },
  "dialog": {
    "confirmDeleteTitle": "Confirm delete",
    "unsavedChangesTitle": "Unsaved changes",
    "unsavedChangesBody": "You have unsaved changes. Discard them?",
    "discard": "Discard"
  },
  "empty": {
    "noResults": "No results.",
    "noData": "No data available."
  },
  "image": {
    "loading": "Loading image...",
    "imageNotFound": "Image not found",
    "loadFailed": "Failed to load image",
    "missingArtifactRef": "Missing artifact reference",
    "imageUnavailable": "Image unavailable",
    "artifactLabel": "Artifact: {{id}}",
    "embeddedAlt": "Embedded image",
    "couldNotLoad": "⚠ Image could not be loaded",
    "couldNotLoadAria": "Image could not be loaded",
    "couldNotLoadAriaWithAlt": "Image could not be loaded — {{alt}}"
  },
  "citation": {
    "loadingData": "Loading citation data…",
    "loadTimedOut": "Citation data could not be loaded. Please try again.",
    "notAvailable": "Citation content not available.",
    "referencedContent": "Referenced Content",
    "source": "Source:",
    "referencedImageAlt": "Referenced image",
    "download": "Download",
    "filename": "Filename:",
    "documentRole": "Document Role:",
    "dataType": "Data Type:",
    "contentDescription": "Content Description:",
    "metadataUnavailable": "No metadata available for this source.",
    "sourceClassClient": "Client institutional knowledgebase",
    "sourceClassBennie": "Kyronyx expert knowledgebase"
  },
  "callouts": {
    "dataGap": "Data Gap — {{topic}}",
    "dataGapAria": "Data gap: {{topic}}",
    "validationAction": "Validation Action — {{topic}}",
    "validationActionAria": "Validation action: {{topic}}"
  },
  "findings": {
    "noCitationsParseable": "No citation references could be read from this finding’s evidence.",
    "citationLabel": "Citation [{{id}}]",
    "rootCause": "Root Cause",
    "classification": "Classification",
    "crossDimensionRefs": "Cross-Dimension Refs",
    "observation": "Observation",
    "expectedStandard": "Expected Standard",
    "impact": "Impact",
    "recommendation": "Recommendation",
    "missingPlaceholder": "—",
    "themeLabel": "Theme: {{value}}",
    "typeLabel": "Type: {{value}}",
    "primaryLabel": "Primary: {{value}}",
    "attributionLabel": "Attribution: {{value}}",
    "tagLabel": "Tag: {{value}}",
    "supportingSymptoms_one": "{{count}} supporting symptom ({{first}})",
    "supportingSymptoms_other": "{{count}} supporting symptoms ({{first}} … {{last}})",
    "loadingSymptoms": "Loading symptom detail…",
    "symptomMeta": "§{{section}} · Type {{severity}}",
    "symptomMetaLegacy": "§{{section}} · Type {{severity}} · {{legacyId}}",
    "symptomMetaCite": "§{{section}} · Type {{severity}}",
    "symptomMetaLegacyCite": "§{{section}} · Type {{severity}} · {{legacyId}}"
  },
  "clearAll": {
    "idleTitle": "Purge everything",
    "idleDescription": "This action will <strong>permanently delete</strong> all projects, uploaded files, generated reports, run logs and every registered model.",
    "alertHeading": "This action cannot be undone!",
    "alertBody": "All of the following will be permanently removed:",
    "bulletWorkspaces": "All projects, including archived ones and Reggie projects",
    "bulletFiles": "All uploaded files and extracted images",
    "bulletReports": "All runs, findings and generated reports",
    "bulletLogs": "All model call logs",
    "bulletModels": "The whole model registry: every model, its details, versions, access grants and issue log",
    "keptNote": "User accounts, sign-in access, prompts, settings and shared knowledge services are not changed. Model access grants are deleted with the models.",
    "confirmPrompt": "Type {{phrase}} exactly as shown to confirm.",
    "confirmLabel": "Confirmation phrase",
    "cancel": "Cancel",
    "goButton": "Purge everything",
    "purgingTitle": "Purging all data...",
    "connecting": "Connecting...",
    "purgingWorkspaces": "Removing {{count}} project(s)...",
    "removingProjects": "Waiting for {{count}} project(s) to finish deleting...",
    "removingData": "Removing files, logs and registry data...",
    "successTitle": "Everything purged",
    "successBody": "All projects, files, reports, logs and models have been deleted. Redirecting...",
    "readBackNow": "Now: {{projects}} project(s) and {{models}} model(s) remain.",
    "readBackNotEmpty": "The purge reported complete, but {{projects}} project(s) and {{models}} model(s) are still listed. Run it again.",
    "readBackFailed": "The purge finished, but reading the current state back failed. Reload to see what remains.",
    "deletedItemsHeading": "Deleted Items:",
    "goToWorkspaces": "Go to workspaces",
    "errorTitle": "Error",
    "tryAgain": "Try Again",
    "back": "Back",
    "unknownError": "Unknown error occurred",
    "failedToClear": "Failed to purge: {{status}} {{statusText}}",
    "refusedNotAdmin": "Only an administrator can purge everything. Nothing was deleted.",
    "refusedConfirmation": "The confirmation phrase did not match. Nothing was deleted.",
    "noResponseStream": "No response stream",
    "partialFailure": "Some data could not be fully removed. The rest was deleted. Run the purge again to finish.",
    "partialFailureRemaining": "{{count}} project(s) could not be fully deleted in time, so the model registry was left unchanged. Everything else was deleted. Run the purge again to finish.",
    "streamEndedEarly": "The server stopped reporting before it confirmed the purge finished, so some data may remain. Run the purge again to check.",
    "connectionLost": "Connection lost. Checking whether the purge has finished...",
    "connectionLostUnconfirmed": "The connection dropped and we could not confirm the purge has finished. Reload this page to check, and run it again if projects or models remain.",
    "readBackUnavailable": "The current state could not be read back, so it is not known what remains. Reload this page and run the purge again if needed."
  },
  "serviceTypeGrants": {
    "title": "Deployment access for {{name}}",
    "body": "This decides what kinds of work this person is cleared for across the whole deployment. It is separate from what they can change on this model.",
    "currentHeading": "Cleared for",
    "empty": "Nothing has been enabled for this person directly.",
    "groupNote": "Access can also come from a directory group. Group access is managed in your directory and is not listed here.",
    "grantHeading": "Enable another kind of work",
    "pickLabel": "Kind of work",
    "neededHint": "needed here",
    "grant": "Enable",
    "revoke": "Remove",
    "close": "Close",
    "failedGeneric": "That change could not be saved. Nothing was changed."
  },
  "modelInventory": {
    "title": "Model Inventory",
    "description": "Browse and manage your model catalog. Select a category to view models.",
    "modelsCount_one": "{{count}} model",
    "modelsCount_other": "{{count}} models",
    "backToInventory": "← Back to Model Inventory",
    "modelsInCategory_one": "{{count}} model in this category",
    "modelsInCategory_other": "{{count}} models in this category",
    "searchPlaceholder": "Search models…",
    "noModels": "No models found.",
    "fallbackTitle": "Models",
    "statusActive": "Active",
    "statusDraft": "Draft",
    "statusDeprecated": "Deprecated",
    "versionUpdated": "v{{version}} • Updated {{date}}",
    "ariaCollapse": "collapse",
    "ariaExpand": "expand",
    "ownerLabel": "Owner: {{value}}",
    "frameworkLabel": "Framework: {{value}}",
    "categoryLabel": "Category: {{value}}",
    "dataLabel": "Data: {{value}}"
  },
  "appAuth": {
    "title": "Access required",
    "body": "This environment is password-protected. Please enter the access password to continue.",
    "passwordLabel": "Password",
    "passwordAria": "Access password",
    "noPasswordHint": "If you don't have the password, please reach out to the project owner.",
    "submit": "Enter",
    "submitting": "Checking…",
    "incorrectPassword": "Incorrect password.",
    "apiUnreachable": "Could not reach the API. Check your connection and try again.",
    "sessionExpired": "Session expired or password was rejected. Please re-enter.",
    "identityUnavailable": {
      "title": "Bennie is temporarily unavailable",
      "body": "We couldn’t check your session. Please try again in a moment.",
      "retry": "Try again"
    },
    "ssoBootstrap": {
      "signingBackIn": "Signing you back in…",
      "stuckTitle": "Sign-in is taking longer than expected",
      "stuckBody": "We couldn’t restore your session. Please try signing in again.",
      "tryAgain": "Try again"
    }
  },
  "modelActions": {
    "edit": "Edit name & type",
    "archive": "Archive",
    "alreadyArchived": "Archived",
    "editTitle": "Edit name & type",
    "editSubtitle": "You can change the model’s name and type.",
    "nameLabel": "Model name",
    "typeLabel": "Model type",
    "typeHelp": "Choose from the types offered for this model. The saved value stays available even if it is no longer offered.",
    "typeMenuUnavailable": "The type list is temporarily unavailable, so the type can't be changed right now. The name can still be edited.",
    "fixedTitle": "Stream path and applied tags can’t be edited.",
    "fixedBody": "They were fixed at registration.",
    "concurrencyTitle": "If someone else edits this model first, your save is refused.",
    "concurrencyBody": "You will be shown their version and asked to review it again.",
    "cancel": "Cancel",
    "save": "Save changes",
    "saving": "Saving…",
    "archiveTitle": "Archive this model?",
    "archiveSubtitle": "Archiving cannot be undone.",
    "archiveOneWayTitle": "This cannot be undone.",
    "archiveOneWayBody": "{{name}} moves to the archived list, stays visible to everyone, and can no longer be changed by anyone — administrators included.",
    "archiveBeneathTitle": "What changes beneath it.",
    "archiveBeneathBody": "No new projects can be created under this model. Its existing projects are marked locked and Test Ground becomes read-only. Everything already produced stays readable and downloadable.",
    "archiveRunningTitle": "Work already running is not stopped.",
    "archiveRunningBody": "Archiving changes this model’s status. It does not cancel a report run, an ingestion or an upload that is already under way. Anything already started keeps going, and finishes into a model that is by then read-only.",
    "confirmLabel": "Type the model name to confirm",
    "archiveGo": "Archive permanently",
    "archiving": "Archiving…",
    "errorGeneric": "That change could not be saved. Please try again in a moment.",
    "errorTimeout": "That change took too long and was stopped, so we can't confirm whether it was saved. Reopen the model to see where it stands before trying again."
  },
  "modelHome": {
    "titleUnknown": "Model",
    "loading": "Loading model",
    "errorNotFound": "This model could not be found. It may have been removed, or the link may be incorrect.",
    "errorLoad": "This model could not be loaded right now. Please try again in a moment.",
    "statusActive": "Active",
    "statusArchived": "Archived",
    "fieldModelId": "Model ID",
    "fieldModelType": "Model type",
    "fieldScopePath": "Scope",
    "fieldProductCategory": "Product category",
    "filterAll": "All {{count}}",
    "filterType": "{{type}} {{count}}",
    "projectsFilterLabel": "Filter projects by line of defence",
    "pagerProjectsAll_one": "Showing {{from}}–{{to}} of {{count}} project",
    "pagerProjectsAll_other": "Showing {{from}}–{{to}} of {{count}} projects",
    "projectsEmpty": "No projects are registered under this model yet.",
    "projectsLoading": "Loading projects",
    "projectsLoadFailed": "Projects could not be loaded right now. Please try again in a moment.",
    "projectsSearchPlaceholder": "Search projects",
    "projectsNoMatch": "No projects match your search.",
    "projectArchiveTitle": "Archive this project?",
    "projectArchiveBody": "{{name}} moves to the archived list and can no longer be changed by anyone. It stays visible and can still be opened. Nothing deletes a project.",
    "projectArchiveConfirmLabel": "Type the project name to confirm",
    "projectArchiveFailed": "This project could not be archived. Please try again.",
    "projectsArchivedEmpty": "No archived projects.",
    "lockedByModel": "Locked — model archived",
    "archivedDirectly": "Archived",
    "parkRunning": "Adding your exported files to the new project…",
    "parkFailedTitle": "The files were not added",
    "parkFailed": "Your exported files could not be added to the new project.",
    "tabOverview": "Overview",
    "tabProjects": "Projects",
    "tabTestGround": "Test Ground",
    "tabToolbox": "Toolbox",
    "pagerProjects_one": "Showing {{from}}–{{to}} of {{count}} {{type}} project",
    "pagerProjects_other": "Showing {{from}}–{{to}} of {{count}} {{type}} projects",
    "sectionEmpty": "No {{type}} work has been started on this model.",
    "serviceTypeUnset": "No service type",
    "tabAccess": "Access",
    "lockArchivedOn": "Archived {{date}}.",
    "lockPill": "Read-only",
    "projectsLockTitle": "These projects are locked, and they are still yours to read.",
    "projectsLockBody": "You can open the report, read the issue log, download the export, and keep chatting with the project.",
    "projectsLockPill": "Read-only · chatable",
    "createDeniedForTypeTitle": "You can’t start {{type}} work on this model yet.",
    "stillWorking": "Still working. This can take a moment.",
    "retry": "Try again",
    "recheckFailed": "This model’s status could not be re-checked just now. What you see is the record last confirmed by the server.",
    "recheckRetry": "Check again"
  },
  "modelList": {
    "title": "Models",
    "subtitle": "{{count}} registered",
    "empty": "No models are registered yet.",
    "loading": "Loading models",
    "errorLoad": "Models could not be loaded right now. Please try again in a moment.",
    "statusActive": "Active",
    "statusArchived": "Archived",
    "searchPlaceholder": "Search models",
    "noMatch": "No models match your search.",
    "clearSearch": "Clear search",
    "stillWorking": "Still working…",
    "retry": "Try again",
    "register": "Register model",
    "registerFirst": "Register the first model",
    "perPage": "Per page",
    "tabActive": "Active {{count}}",
    "tabArchived": "Archived {{count}}",
    "prev": "Prev",
    "next": "Next"
  },
  "modelAccess": {
    "lockTitle": "Access is frozen on an archived model.",
    "lockBody": "The record of who held what stays visible as part of the audit trail. Nothing on it can be changed, including ownership.",
    "lockPill": "Read-only",
    "standingHeading": "Where you stand",
    "standingOwner": "You are this model’s owner.",
    "standingCollaborator": "You are a collaborator on this model.",
    "standingNone": "You hold no access on this model.",
    "standingOtherRole": "You hold an access role on this model.",
    "standingAdminOverride": "Administrator override",
    "subjectAdminBadge": "Administrator",
    "standingMayWrite": "You can make changes to this model where the product offers them.",
    "standingNothingToPress": "Access is managed by the owner.",
    "identityPending": "Still confirming which account you are signed in as.",
    "ownerHeading": "Owner",
    "ownerHint": "A model has one owner, who decides who else can change it.",
    "ownerIsYou": "You own this model.",
    "ownerNoAllowances": "Owners hold every permission through their role.",
    "collaboratorsHeading": "Collaborators",
    "recordHeading": "Record",
    "registeredBy": "Registered by {{who}}.",
    "registeredByOn": "Registered by {{who}} on {{date}}.",
    "registrarNotOwner": "This is who registered the model, not necessarily who owns it now.",
    "archivedBy": "Archived by {{who}}.",
    "archivedByOn": "Archived by {{who}} on {{date}}.",
    "accountIdLabel": "Account ID",
    "you": "you",
    "noDefaultGrant": "Anyone can read this model and the projects beneath it. Only the owner and people granted access can make changes.",
    "retry": "Try again",
    "loadFailedTitle": "We couldn’t load who has access",
    "ownerMissing": "This model has no owner on record. An administrator can assign one.",
    "ownerSince": "Owner since {{date}} · granted by {{by}}",
    "collaboratorsHint": "Everyone in your organization can read this model and everything beneath it, including its test workspaces, and everyone can use Toolbox. A collaborator can change the work of the service types ticked for them; the Collaborator tick lets them change test workspaces.",
    "collaboratorsNone": "Nobody else has been given anything to change on this model.",
    "colPerson": "Person",
    "colCanChange": "Can change",
    "colAddedBy": "Added by",
    "transferOpen": "Transfer ownership…",
    "addOpen": "Add collaborator",
    "editOpen": "Edit",
    "removeOpen": "Remove",
    "transferTitle": "Transfer ownership",
    "transferBody": "The new owner takes over everything you can do here, and you stop being able to do it.",
    "transferNewOwnerLabel": "New owner",
    "transferKeepsNothing": "You will keep nothing on this model. You can still read it, like everyone else, but you will no longer be able to change it or decide who can.",
    "transferSubmit": "Transfer ownership",
    "subjectIdHelper": "Anyone with Bennie access, administrator or not. You can also paste a directory object id.",
    "subjectSearchPlaceholder": "Search by name or email",
    "principalSearchIdle": "Start typing a name or email to find someone.",
    "principalSearchTooShort": "Keep typing — a search needs at least three characters.",
    "principalSearching": "Searching your organization’s directory…",
    "principalSearchMatches": "Choose the right person from the list.",
    "principalSearchTruncated": "Only the closest matches are shown — narrow your search if you do not see them.",
    "principalSearchNoMatch": "No one in your organization matches that. Check the spelling, or paste their directory object id.",
    "principalSearchUnavailable": "The directory could not be reached, so it could not be searched. Try again in a moment — this does not mean nobody matches.",
    "principalResolving": "Looking this person up…",
    "principalNotFound": "No one in your organization has that id. Check it before continuing — nothing has been changed.",
    "principalUnavailable": "The directory could not be reached, so this id could not be checked. Try again in a moment; nothing has been changed.",
    "transferConfirmHint": "This is who will own the model. Confirm it is the right person — this cannot be undone.",
    "addConfirmHint": "This is who will be added to the model.",
    "addTitle": "Add a collaborator",
    "addSubjectLabel": "Person",
    "addSubmit": "Add collaborator",
    "editTitle": "Edit allowances",
    "editSubmit": "Save allowances",
    "allowancesHeading": "What they can change",
    "allowancesHint": "Tick the kinds of work this person may change on this model. Collaborator lets them change test workspaces.",
    "allowancesNoneNotice": "They will be added without permission to make changes. You can grant it later.",
    "allowancesUnrestricted": "Not limited by service type",
    "allowancesNothingYet": "Nothing yet",
    "entitlementShortfall": "Granted here, but not enabled for {{types}} across the deployment — an administrator has to enable that separately before this takes effect.",
    "entitlementUnknown": "We couldn’t check this person’s deployment-wide access just now.",
    "entitlementManage": "Enable it now",
    "allowancesOther": "Other",
    "allowanceCollaborator": "Collaborator",
    "removeTitle": "Remove this person?",
    "removeBody": "They lose everything they could change on this model. They can still read it, like everyone else.",
    "removeSubmit": "Remove",
    "cancel": "Cancel",
    "working": "Working…"
  },
  "modelRegister": {
    "title": "Register a model",
    "subtitle": "Choose what the model is, then name it. Administrators only.",
    "step1Title": "Choose the model",
    "step1Hint": "The same menu you use to start a project",
    "step2Title": "Continue",
    "step2Hint": "Opens a dialog to finish registering",
    "step3Title": "Name the model",
    "step3Hint": "Name it, and check the path you picked",
    "step4Title": "Model homepage",
    "step4Hint": "You land there automatically",
    "pickerHeading": "Choose what this model is",
    "pickerHint": "The same menu you use to start a project. Choose all the way down to the last level.",
    "adminOnly": "Registering a model is an administrator action. You can walk the menu here, but only an administrator can complete the registration.",
    "leave": "Leave",
    "dialogTitle": "Register a model",
    "dialogSubtitle": "Name it and check the path you picked.",
    "sectionIdentity": "1 · Identity",
    "nameLabel": "Model name",
    "namePlaceholder": "A name that tells this model apart",
    "nameHelper": "The only thing you type here. Choose a name that tells this model apart from others of the same type.",
    "summaryStreamPath": "Stream path",
    "summaryAppliedTo": "Applied to",
    "summaryAppliedToNone": "Nothing narrowed — the whole stream.",
    "permanent": "Permanent. Every project, Test Ground workspace and Toolbox job under this model inherits this path.",
    "sectionCanonicals": "3 · Model canonicals",
    "canonicalsHint": "Optional. Fill in what you know now, and add or change any of it once the model is registered.",
    "canonicalsUnavailableAbsent": "The canonical fields can't be shown right now. Register the model, then add them from its page — and let your administrator know they are unavailable.",
    "canonicalsUnavailableUnreachable": "The canonical fields can't be shown right now. Register the model and add them from its page in a few minutes.",
    "canonicalsUnavailableGeneric": "The canonical fields can't be shown right now. Register the model and add them from its page.",
    "canonicalsLoading": "Loading the canonical fields",
    "cancel": "Cancel",
    "submit": "Register model",
    "submitting": "Registering…",
    "stillWorking": "Still working. This can take a moment.",
    "retry": "Try again",
    "errName": "Give the model a name before registering it.",
    "errNotPermitted": "Registering a model is an administrator action, and this account is not one.",
    "errScope": "The menu path chosen for this model was not accepted. Go back a step and choose it again.",
    "errUnavailable": "The service menu is not answering right now, so this model cannot be registered yet. Try again shortly.",
    "errTimeout": "Registering took too long and was stopped, so we could not confirm whether the model was created. Open the model registry to check before registering it again.",
    "errGeneric": "The model could not be registered. Please try again.",
    "readBackFailed": "The model was registered. We could not open it just now — try again, or open it from the model registry. Do not register it a second time.",
    "readBackRetry": "Try opening it again"
  },
  "modelTestGround": {
    "hint": "An isolated place to compose and run model logic against your own data.",
    "newWorkspace": "New test workspace",
    "inheritedScope": "Inherited scope",
    "from": "From",
    "onModel": "on <strong>{{model}}</strong>",
    "playground": "Pipelines here can be run, exported into a project and cited. They are not part of the model’s canonical record.",
    "searchPlaceholder": "Search test workspaces…",
    "count_one": "{{count}} test workspace",
    "count_other": "{{count}} test workspaces",
    "perPage": "Per page",
    "pagerShowing_one": "Showing {{from}}–{{to}} of {{count}} test workspace",
    "pagerShowing_other": "Showing {{from}}–{{to}} of {{count}} test workspaces",
    "loading": "Loading test workspaces",
    "stillWorking": "Still working…",
    "errorLoad": "Test workspaces could not be loaded right now. Please try again in a moment.",
    "empty": "No test workspaces on this model yet.",
    "noMatch": "No test workspaces match your search.",
    "lockTitle": "Test Ground is readable on an archived model, and will not run.",
    "lockBody": "Past test workspaces, their configuration and every run result stay open. New workspaces and edits are off.",
    "lockPill": "Read-only",
    "writeDenied": "You do not have permission to make changes on this model.",
    "createScopeRejected": "Test Ground cannot use this model’s scope. The scope is set on the model.",
    "lastActive": "last active {{date}}",
    "readinessSteps_one": "{{count}} ready-made step is available for this scope",
    "readinessSteps_other": "{{count}} ready-made steps are available for this scope",
    "readinessNone": "This scope has no ready-made steps. Custom node always works.",
    "readinessUnavailable": "Ready-made steps for this scope could not be checked."
  },
  "modelCanonicalFields": {
    "description": "Description",
    "business_unit": "Business unit",
    "risk_tier": "Risk tier",
    "lifecycle_stage": "Lifecycle stage",
    "built_or_bought": "Built or bought",
    "regulatory_framework": "Regulatory framework"
  },
  "modelOverview": {
    "mdrTitle": "Model development report",
    "mdrHint": "The approved version is the one every report run reads. Everyone can see the history and download any version; approving requires permission.",
    "mdrLoading": "Loading the report history",
    "mdrStillWorking": "Still working…",
    "mdrErrorLoad": "The report history could not be loaded right now. Please try again in a moment.",
    "retry": "Try again",
    "mdrEmpty": "No development report has been uploaded for this model yet.",
    "mdrAllWithdrawn": "Every version of this model's development report has been withdrawn, so the model has no current documentation. The history is below.",
    "mdrCurrentApproved": "This is the approved version — the one the registry treats as current.",
    "mdrNoneApproved": "No version is approved, so this model has no current report. The newest version that has not been withdrawn is shown.",
    "mdrUnapprovedInheritance": "No version is approved. Plan generation for workspaces under this model uses the latest version awaiting approval as an unapproved draft reference; with none, it runs without a report.",
    "mdrHistoryHeading": "Version history ({{count}})",
    "mdrHistoryNote": "All versions stay listed.",
    "parse": "Parse canonicals",
    "parsing": "Parsing…",
    "parseCancel": "Stop",
    "parseNotReadable": "A withdrawn version can't be read.",
    "parseFailed": "The report could not be read.",
    "parseStopped": "Reading stopped. Nothing was proposed and nothing was saved.",
    "parseDone": "Reading finished. The proposals are open for review below — nothing is saved until you save it.",
    "mdrColFile": "File",
    "mdrColStatus": "Status",
    "mdrColUploaded": "Uploaded",
    "mdrColActions": "Actions",
    "statusApproved": "Approved",
    "statusExempted": "Exempted",
    "exempt": "Exempt",
    "unexempt": "Remove exemption",
    "exemptFailed": "The exemption did not finish, and we can't confirm whether it was recorded. Refresh to check before trying again.",
    "statusDraft": "Pending approval",
    "statusSuperseded": "Superseded",
    "statusWithdrawn": "Withdrawn",
    "statusUnknown": "Status unavailable",
    "download": "Download",
    "approve": "Approve",
    "approving": "Approving…",
    "approveAlready": "This version is already approved.",
    "approveNotPromotable": "This version cannot be approved.",
    "approveFailed": "The approval did not finish, and we can't confirm whether the version was approved. Refresh to check before trying again.",
    "upload": "Upload new version",
    "uploading": "Uploading…",
    "uploadInFlightNote": "This file is not in the list below, and will not appear there until the upload finishes.",
    "uploadFailed": "The upload did not finish, and we can't confirm whether the new version was recorded. Refresh to check before uploading it again.",
    "mdrApprovalNote": "Every version starts pending approval. Only one version can be approved at a time.",
    "mdrDownloadNote": "Download only.",
    "canonTitle": "Model canonicals",
    "canonHint": "What the owner declares is true about this model. It is read into every report run exactly as declared.",
    "canonErrorLoad": "The canonicals could not be read right now. Please try again in a moment.",
    "canonLoading": "Reading the canonicals",
    "canonStillWorking": "Still reading…",
    "canonEmpty": "Nobody has declared anything about this model yet.",
    "canonUpdatedBy": "Last updated {{date}} by {{actor}}.",
    "canonUpdatedUnknownActor": "Last updated {{date}}. Who made the change was not recorded.",
    "canonOwnerLabel": "Model owner",
    "canonOwnerNone": "No owner is recorded for this model.",
    "canonOwnerUnavailable": "The owner cannot be shown right now.",
    "canonUnreviewedBadge": "Extracted — awaiting confirmation",
    "canonEdit": "Edit",
    "canonEditing": "Editing…",
    "canonEditNotice": "Nothing is saved until you save. Saving records the values you changed and confirms the ones you left as they are.",
    "canonSave": "Save changes",
    "canonSaving": "Saving…",
    "canonCancel": "Cancel",
    "canonEditFootnote": "Saving updates every field in this block.",
    "canonNoClear": "A value can be changed but not removed.",
    "canonNoClearBlock": "A canonical that has a value cannot be emptied — it can only be changed. Put a value back into {{fields}}, or press Cancel to leave it as it was.",
    "canonSaveFailedTitle": "Nothing was saved.",
    "canonSavePartialTitle": "Part of this block was saved: {{saved}} field(s) saved, {{failed}} did not.",
    "canonSavedFields": "Saved: {{fields}}.",
    "canonFieldFailed": "{{field}} — {{reason}}",
    "canonReloadFailed": "Your changes were sent, but the block could not be read back, so what is shown may not be what the registry now holds. Reload the page before editing again.",
    "issuesTitle": "Issue log",
    "issuesHint": "Every finding across every live project under this model. A finding’s status is changed here.",
    "issuesEmpty": "No issues have been recorded for this model. Findings appear here once its validation and auditing projects have run.",
    "issuesLoading": "Loading the issue log",
    "issuesStillWorking": "Still loading the issue log…",
    "issuesErrorLoad": "The issue log could not be loaded. Please try again.",
    "issuesSaveFailed": "That change could not be saved. Please try again.",
    "issuesColIssue": "Issue",
    "issuesColService": "Service",
    "issuesColSeverity": "Severity",
    "issuesColTitle": "Title",
    "issuesColTheme": "Theme",
    "issuesColProject": "Project",
    "issuesColAssignee": "Assignee",
    "issuesColStatus": "Status",
    "issuesColLastAction": "Last action",
    "issuesServiceValidation": "Validation",
    "issuesServiceAuditing": "Auditing",
    "issuesServiceDevelopment": "Development",
    "issuesServiceUnknown": "Unknown",
    "issuesStatusActive": "Active",
    "issuesStatusRemediating": "Remediating",
    "issuesStatusResolved": "Resolved",
    "issuesStatusUnknown": "Unknown",
    "issuesNoLongerDetected": "No longer detected",
    "issuesUnassigned": "Unassigned",
    "issuesAssigneeLoading": "Loading the people this model can be assigned to.",
    "issuesAssigneeUnavailable": "The people this model can be assigned to could not be read, so the assignee cannot be changed.",
    "issuesOpenDetail": "Open “{{title}}”",
    "issuesDetailDescription": "Description",
    "issuesSourceUnknown": "Source provenance unavailable",
    "issuesSourceUnversioned": "Unversioned source",
    "issuesSourceReport": "From Report V{{version}}",
    "issuesSourceReportUnknown": "Report version number not recorded",
    "issuesSourceRun": "Run {{id}}",
    "issuesSourceItem": "Item {{id}}",
    "issuesOpenInProject": "Open in project",
    "issuesReasonRequired": "Give a reason for the status change.",
    "issuesReasonLabel": "Reason",
    "issuesStatusConfirm": "Save",
    "issuesCancel": "Cancel",
    "issuesActionEscalated": "Escalated",
    "issuesActionStatusChanged": "Status changed to {{status}}",
    "issuesActionAssigneeChanged": "Owner changed",
    "issuesActionStamp": "{{date}} · {{who}}",
    "startTitle": "Start work on this model",
    "startHint": "Three quick actions. Your grant decides which of them you can press.",
    "lineDevelopment": "Development",
    "lineValidation": "Validation",
    "lineAuditing": "Auditing",
    "lodDevelopment": "1st line of defence",
    "lodValidation": "2nd line of defence",
    "lodAuditing": "3rd line of defence",
    "lockTitle": "This model is archived — everything here stays viewable, and its own details can no longer be changed.",
    "lockBody": "Reports, canonicals, the issue log, Test Ground runs and Toolbox jobs all stay readable, and the projects beneath it stay open to read and to chat with.",
    "approveConfirmTitle": "Approve this version?",
    "approveConfirmBody": "Approving makes this the version every report on this model reads as current documentation. Other people's work depends on it. You can approve a different version later.",
    "approveConfirmGo": "Approve version",
    "withdraw": "Withdraw",
    "withdrawing": "Withdrawing…",
    "withdrawAlready": "Already withdrawn. This cannot be undone.",
    "withdrawNotWithdrawable": "This version cannot be withdrawn.",
    "withdrawFailed": "The withdrawal did not finish, and we can't confirm whether the version was withdrawn. Refresh to check before trying again.",
    "withdrawConfirmTitle": "Withdraw this version?",
    "withdrawTerminalBody": "Withdrawing retires a version. It does not delete it — the file stays in the list and stays downloadable. What it cannot do again is become current: a withdrawn version cannot be approved, and it cannot be un-withdrawn. Upload a new version instead.",
    "withdrawLeavesNoCurrentTitle": "This is the current approved report, so this model will have none.",
    "withdrawLeavesNoCurrentBody": "Withdrawing the approved version leaves this model with no current documentation, and every report run on it will read that as nothing declared. Approve another version or upload a new one first if that is not what you mean.",
    "withdrawReasonLabel": "Reason",
    "withdrawReasonPlaceholder": "e.g. uploaded against the wrong model",
    "withdrawReasonHelper": "Recorded with your name and a timestamp against the version.",
    "withdrawConfirmGo": "Withdraw version",
    "canonVocabLoading": "Loading the values allowed for these fields…",
    "canonVocabErrorAbsent": "The list of values allowed for these fields has not been published for this deployment, so the canonicals cannot be edited. Retrying will not help — please contact support.",
    "canonVocabErrorUnreachable": "The list of values allowed for these fields could not be loaded just now, so the canonicals cannot be edited. Try again in a moment.",
    "canonVocabErrorGeneric": "The list of values allowed for these fields could not be read, so the canonicals cannot be edited. Try again — if it keeps happening, contact support.",
    "canonVocabUnset": "Not declared",
    "canonVocabOffValue": "{{value}} — not in the current list",
    "canonVocabRetiredValue": "{{label}} — no longer offered",
    "canonVocabOffHelp": "This value came from the model document and is kept exactly as it was worded there. Leave it as it is, or choose one of the listed values.",
    "canonVocabRetiredHelp": "This value is no longer offered for new entries. It is kept as it is until someone chooses a different one.",
    "canonVocabDocumentWording": "The model document states: “{{wording}}”. It is not one of the listed values, so set this field yourself.",
    "issuesSearch": "Search issue, title, theme, project or person…",
    "issuesFilterNoTheme": "No theme",
    "issuesFilterUnnamed": "Name not shown",
    "evidenceTitle": "Evidence",
    "evidenceLoading": "Loading evidence",
    "evidenceEmpty": "No files attached.",
    "evidenceErrorLoad": "The attached files could not be loaded.",
    "evidenceAdd": "Attach file",
    "evidenceDownload": "Download",
    "evidenceRemovePending": "Remove",
    "evidencePendingHint": "Not saved",
    "evidenceWithdraw": "Withdraw",
    "evidenceUndoWithdraw": "Keep",
    "evidenceWithdrawStage": "Mark for withdrawal",
    "evidenceWithdrawReasonLabel": "Why is this being withdrawn?",
    "evidenceMeta": "Attached by {{who}} on {{when}}",
    "evidenceWithdrawnStamp": "Withdrawn by {{who}} on {{when}}: {{reason}}"
  },
  "serviceMenu": {
    "unavailableTitle": "The list of service areas could not be loaded",
    "unavailableBody": "This is usually temporary. Try again in a moment.",
    "stillWorking": "Still working…",
    "emptyTitle": "No service areas are available",
    "emptyBody": "Nothing is available to choose from. Contact your administrator if you expected to see options."
  },
  "dashboard": {
    "title": "Dashboard",
    "subtitle": "The portfolio, one row per model.",
    "loading": "Loading the portfolio view",
    "stillWorking": "Still working…",
    "retry": "Try again",
    "errorTitle": "We couldn’t load the portfolio view",
    "errorBody": "The request didn’t complete. This is usually temporary.",
    "errorOneMessage": "If this keeps happening, please contact support.",
    "emptyTitle": "Nothing to report on yet",
    "emptyBody": "The portfolio view fills in once models are registered and work has been done under them.",
    "emptyOnlyOnSuccess": "Nothing failed to load; the portfolio is simply empty.",
    "periodScope": "The period applies to the models and projects shown, not to validation completion or the open-issue figures.",
    "refreshedScope": "Refreshed describes the time-saved figure, recomputed at most hourly. Other figures are read fresh on every load.",
    "refreshed": "Refreshed {{when}}",
    "refreshedUnknown": "Refresh time unavailable",
    "period": {
      "label": "Period",
      "p7d": "7d",
      "p30d": "30d",
      "p90d": "90d",
      "p1y": "1 year",
      "custom": "Custom"
    },
    "countsBy": {
      "label": "Counts by",
      "activity": "Activity",
      "created": "Created"
    },
    "showArchived": "Show archived",
    "warmingTitle": "Preparing the portfolio view",
    "warmingBody": "This usually takes under a minute, and the page will fill in on its own.",
    "warmingStuckTitle": "Still preparing after a long wait",
    "warmingStuckBody": "The portfolio figures have not arrived. You can wait, or ask for them again.",
    "staleTitle": "These figures are older than they should be — they are from {{when}}",
    "staleBody": "The last refresh did not complete, so this data may be out of date.",
    "refreshNow": "Refresh now",
    "partialTitle": "Some of this page could not be read",
    "partialBody": "The figures below cover only what could be read. Counts that would be misleading are withheld.",
    "kpi": {
      "models": "Registered models",
      "modelsSub": "{{projects}} projects beneath them",
      "modelsSubNoProjects": "Project count unavailable",
      "modelsTooltip": "Models matching the selected period.",
      "approved": "Approved report",
      "validated": "Validated",
      "validatedSub": "Completed in this period",
      "validatedWithheld": "Withheld. This figure counts models by their projects, and the project list could not be read.",
      "validatedTooltip": "Counts models with at least one validation project that reached the terminal state.",
      "openIssues": "Open issues",
      "openIssuesSub": "T1 {{t1}} · T2 {{t2}} · T3 {{t3}} · T4 {{t4}}",
      "openIssuesWithheld": "Withheld. Only part of the issue data could be read — a partial count would show fewer open issues than there are.",
      "openIssuesTooltip": "Findings escalated into a model’s issue log that are still open, across the models in view.",
      "timeSaved": "Time saved",
      "timeSavedSub": "≈ {{weeks}} FTE-weeks · {{n}} projects",
      "timeSavedSubWeeksOnly": "≈ {{weeks}} FTE-weeks",
      "timeSavedNoData": "No measured projects yet",
      "timeSavedWithheld": "Withheld. The measurement data could not be read.",
      "approvedSub": "{{n}} have no report",
      "approvedWithheld": "Withheld. The report ledger could not be read.",
      "approvedTooltip": "Counts models with an approved report version, out of the models in view."
    },
    "coverage": {
      "title": "Coverage",
      "hint": "One row per model, one column per line of defence. Click a row to open the model.",
      "search": "Search name, identifier, type, stream or registrar…",
      "stream": "Stream",
      "allStreams": "All streams",
      "colModel": "Model",
      "col_development": "Development",
      "col_validation": "Validation",
      "col_auditing": "Auditing",
      "colLastActivity": "Last activity",
      "neverOpened": "Never opened",
      "clearFilters": "Clear",
      "showing_one": "Showing {{from}}–{{to}} of {{count}} model",
      "showing_other": "Showing {{from}}–{{to}} of {{count}} models",
      "perPage": "Per page",
      "cellComplete": "Complete",
      "cellInProgress": "In progress",
      "cellNone": "None",
      "tier": "Risk tier",
      "allTiers": "All risk tiers",
      "colTier": "Tier",
      "tierNotSet": "Not set",
      "colApproval": "Approval",
      "approvalApproved": "Approved",
      "approvalPending": "Pending",
      "approvalNone": "No report",
      "cellStale": "Older",
      "colCoverage": "Development · Validation · Auditing",
      "segment": "{{line}}: {{state}}",
      "noMatchTitle": "No models match these filters",
      "noMatchBody": "Try a different search term, stream or risk tier.",
      "noPeriodTitle": "No models in this period",
      "noPeriodBody": "No registered model has activity in the selected period. Choose a longer period above to bring them back.",
      "colCreated": "Created",
      "clearFiltersAction": "Clear filters",
      "showingNone": "Showing 0 of 0 models",
      "legendStaleLabel": "Complete, before period",
      "prevPage": "Previous page",
      "nextPage": "Next page"
    },
    "validation": {
      "title": "Validation recency",
      "hint": "No due dates, so nothing is marked overdue.",
      "chartWithheld": "Validation recency can’t be shown because the project list could not be read.",
      "chartOmitted": "Not grouped by age: {{n}} models whose validations have no completion date.",
      "barMonths": "{{n}} mo",
      "summaryValidated": "<b>{{n}}</b> validated",
      "summaryNever": "<b>{{n}}</b> never",
      "bucket0": "0–4 months",
      "bucket1": "4–8 months",
      "bucket2": "8–12 months",
      "bucket3": "Over 12 months",
      "bucketNever": "Never validated",
      "never": "Never",
      "footer": "{{n}} models · oldest {{months}} months",
      "emptyTitle": "No validation records yet",
      "emptyBody": "Models with a completed validation appear here, ordered by time since it finished. Nothing is marked overdue.",
      "swipeHint": "Swipe for more groups",
      "scrollMore": "Scroll for {{n}} more",
      "allShown": "All shown"
    },
    "issues": {
      "title": "Open issues by model",
      "hint": "Escalated into each model’s issue log, and still open.",
      "stream": "Stream",
      "allStreams": "All streams",
      "search": "Search models",
      "unavailable": "The escalated issue counts could not be read.",
      "reading": "Reading the escalated issue counts…",
      "tier": "T{{n}} · {{name}}",
      "groupModels_one": "{{count}} model",
      "groupModels_other": "{{count}} models",
      "summary": "{{n}} models in {{streams}} streams · {{total}} open issues",
      "emptyTitle": "No open issues",
      "emptyBody": "Findings appear here once they are escalated into a model’s issue log and while they stay open.",
      "footnote": "Only escalated findings are counted. Findings that are only in a project’s own log are not.",
      "scrollFor": "Scroll for {{count}} more",
      "allShown": "All shown",
      "more": "{{count}} more"
    },
    "hygiene": {
      "title": "Registry hygiene",
      "hint": "Whole active registry, not the selected period. Review a row to see its models.",
      "noReport": "Models with no development report",
      "noReportSub": "Nothing uploaded against them yet.",
      "pending": "Reports waiting on approval",
      "pendingSub": "Uploaded, not approved, so no current report.",
      "canonicals": "Canonicals never confirmed",
      "canonicalsSub": "Proposed by the report parse, not confirmed since.",
      "noProject": "Models with no project",
      "noProjectSub": "Registered and never opened.",
      "review": "Review",
      "colModel": "Model",
      "colOwner": "Registered by",
      "colRegistered": "Registered",
      "notListed": "Not listed: models with no mapped ID and projects with no model.",
      "hide": "Hide"
    },
    "completed": {
      "title": "Reports completed",
      "hint": "Projects that reached the terminal state, counted in the month they were marked complete.",
      "withheld": "This chart is drawn from the projects beneath each model, and the project list could not be read.",
      "omitted": "Not counted: {{n}} completed projects that carry no completion date.",
      "barTooltip": "{{month}} — {{n}} completed",
      "emptyTitle": "No reports completed yet",
      "emptyBody": "A project is counted here in the month it is marked complete, when it locks and its report stops changing. Monthly bars appear after the first one.",
      "yearHeading": "Year",
      "olderYearsBelow_one": "{{count}} older year below",
      "olderYearsBelow_other": "{{count}} older years below",
      "toDate": "to date",
      "allYears": "All years",
      "completedSince": "completed since {{year}}",
      "bestYear": "Best year: {{year}} · {{n}}",
      "completedIn": "completed in <b>{{year}}</b>",
      "completedInSoFar": "completed in <b>{{year}}</b> so far ({{from}}–{{to}})",
      "deltaFirst": "First year on record",
      "deltaSame": "Same as {{year}}",
      "deltaSameMonths": "Same as the same months of {{year}}",
      "deltaMore": "▲ {{n}} more than {{year}}",
      "deltaMoreMonths": "▲ {{n}} more than the same months of {{year}}",
      "deltaFewer": "▼ {{n}} fewer than {{year}}",
      "deltaFewerMonths": "▼ {{n}} fewer than the same months of {{year}}",
      "deltaPct": "({{pct}}%)",
      "avgPerMonth": "{{avg}} per month",
      "peakNone": "No completions",
      "peakMany": "Peak {{peak}} in {{n}} months",
      "peakFew": "Peak {{months}} · {{peak}}",
      "averageTag": "average",
      "chartNote": "All years share one scale, so bars compare across years. Dashed months fall outside the dates covered."
    },
    "review": {
      "search": "Search model, identifier or registrar…",
      "registrarUnnamed": "Name not shown",
      "registrarNone": "No registrar recorded"
    },
    "more": "{{n}} more"
  },
  "projectWsModel": {
    "report": {
      "title": "Model development report",
      "hint": "Loaded from the model this project belongs to.",
      "slotLabel": "Report on file",
      "slotHelp": "The report is maintained on the model, so every project under it reads the same document.",
      "noModelTitle": "This project does not name a model",
      "noModelBody": "A project reads its development report from the model it belongs to. This project has no recorded model, so no report can be loaded.",
      "noModelGap": "The model is recorded when a project is created from a model’s Projects tab.",
      "errorLoad": "The report history could not be loaded right now. This does not mean the model has no report.",
      "retry": "Try again",
      "loading": "Loading the model development report",
      "stillWorking": "Still working…",
      "emptyTitle": "No report on this model yet",
      "emptyBody": "No development report has been uploaded for {{model}} yet. Once one is uploaded and approved on the model, it appears here.",
      "emptyTitleAllWithdrawn": "No current report on this model",
      "emptyBodyAllWithdrawn": "Every development report version on {{model}} has been withdrawn, so there is no current report to show. Once a new one is uploaded and approved on the model, it appears here.",
      "goToModelReport": "Open the model’s report",
      "emptyNoPicker": "Reports are uploaded on the model, not on the project.",
      "metaNoDate": "date unavailable",
      "metaApproved": "Approved · {{date}} · {{model}}",
      "metaLatestUnapproved": "Latest version · {{status}} · {{date}} · {{model}}",
      "metaPrevious": "Previous version · {{status}} · {{date}} · {{model}}",
      "versionGroupAria": "Which version of the report to show",
      "versionCurrent": "Current",
      "versionPrevious": "Previous",
      "autoAddedReference": "Added as a reference",
      "download": "Download",
      "unapprovedNotice": "This version is not approved on the model. It is shown because it is what the model currently holds.",
      "reportBelongsToModel": "This document belongs to the model. It is changed there, and the change reaches every project under it."
    }
  },
  "table": {
    "showing": "Showing {{shown}} of {{total}}",
    "clearFilters": "Clear filters",
    "noMatches": "No rows match your search or filters."
  },
  "chart": {
    "invalidSpec": "This chart could not be displayed because its data is not valid.",
    "loadFailed": "Chart could not be loaded."
  }
}
